import { useState } from 'react'
import MainLayout from '../Layouts/MainLayout'
import Legal from './Legal'

function LegalContainer() {
    const [navParams, setNavParams] = useState({
          navTitle: "Legal",
          navSubTitle: "Welcome to ImagesBazaar"
      })
    
      const handleNavParams = (obj)=>{
        setNavParams({
            ...navParams,
            ...obj
        })
      }
  return (
    <MainLayout navTitle={"Legal"} navSubTitle={"Welcome to ImagesBazaar"}>
      <Legal handleNavParams={handleNavParams}/>
    </MainLayout>
  )
}

export default LegalContainer